import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';
import { createRoot } from 'react-dom/client';

import { AppProviders } from '@/app/providers';
import { appConfig, getRuntimeConfig } from '@/shared/config';

const rootElement = document.getElementById(appConfig.app.rootElementId);

getRuntimeConfig()
  .then((config) => {
    // Scopes the app's Preflight (src/app/styles/preflight.css) and the kit's base styles (data-cuc-root) to this element.
    rootElement!.dataset.appRoot = '';
    rootElement!.dataset.cucRoot = '';
    createRoot(rootElement!).render(<AppProviders config={config} />);
  })
  .catch((error: unknown) => {
    // A broken /config.json: the shell shows its error page instead of a sign-in against nothing.
    console.error(error);
    sendGlobalErrorProps({ errorType: 'generalError' });
  });
